export default __webpack_public_path__ + "static/betql-image-left-1-mobile-3815e1885a31d67ec20fca5debd55dc6.webp";